import { useState, useEffect } from 'react'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import DefaultAxios from 'axios'
import toast from 'react-hot-toast'
import validator from 'validator'
import * as actions from '../../store/modules/auth/actions'

// Material ui
import Box from '@mui/material/Box'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { Container } from './styles'
import { steps } from '../../utils/steps'

// Steps
import CreateInitialDataStep from './steps/CreateInitialDataStep'
import CompanyDataStep from './steps/InstutionDataStep'
import ChooseCompanyPlanStep from './steps/CreateInstitutionAccess'
import { useSelector } from 'react-redux'
import { StoreState } from '../../store'
import Loading from '../Loading'
import api from '../../services/axios'
import { validateDocument } from '../../utils/validate-document'

export type CadastroState = string

export default function Steps() {
    // estado dos inputs de cadastro
    const [fantasy_name, setFantasy_name] = useState<CadastroState>('')
    const [type, setType] = useState<CadastroState>('Selecione')
    const [cnpj_cpf, setCnpj_cpf] = useState<CadastroState>('')
    const [zipcode, setZipcode] = useState<CadastroState>('')
    const [address, setAddress] = useState<CadastroState>('')
    const [number, setNumber] = useState<CadastroState>('')
    const [complement, setComplement] = useState<CadastroState>('')
    const [district, setDistrict] = useState<CadastroState>('')
    const [city, setCity] = useState<CadastroState>('')
    const [state, setState] = useState<CadastroState>('Selecione')
    const [fone, setFone] = useState<CadastroState>('')
    const [email, setEmail] = useState<CadastroState>('')
    // const [login, setLogin] = useState<CadastroState>('')
    const [password, setPassword] = useState<CadastroState>('')
    const [passwordConfirm, setPasswordConfirm] = useState<CadastroState>('')
    const [checkTerms, setCheckTerms] = useState(false)

    // ---------
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { isLoading, registerError } = useSelector(
        (state: StoreState) => state.auth
    )
    const [activeStep, setActiveStep] = React.useState(0)
    const [skipped, setSkipped] = React.useState(new Set<number>())

    useEffect(() => {
        if (zipcode.length !== 9) return

        async function getAdressByZipcode() {
            const zipcodeOnlyNumber = zipcode.replace(/\D/g, '')
            const response = await DefaultAxios.get(
                `https://viacep.com.br/ws/${zipcodeOnlyNumber}/json/`
            )
            if (response.data.erro) return
            const { localidade, logradouro, bairro, uf } = response.data
            setState(uf)
            setCity(localidade)
            setAddress(logradouro)
            setDistrict(bairro)

            // const estado = states.find(state => state.sigla === uf)
        }

        getAdressByZipcode()
    }, [zipcode])

    if (isLoading) {
        return <Loading />
    }

    async function hasStepOneErrors(): Promise<boolean> {
        let errors = false
        try {
            const { data } = await api.get(`/validacao/email?email=${email}`)
            if (data) {
                toast.error('Este email já está em uso')
                errors = true
            }
        } catch (e) {
            toast.error('Ocorreu um erro')
            errors = true
        }
        if (fantasy_name.length < 3 || fantasy_name.length > 54) {
            toast.error('Nome da empresa precisa ter entre 3 e 200 caracteres')
            errors = true
        }

        if (!validator.isEmail(email)) {
            toast.error('Email inválido')
            errors = true
        }

        if (!fone) {
            toast.error('Número de telefone inválido')
            errors = true
        }

        return errors
    }

    async function hasSteptwoErrors(): Promise<boolean> {
        let errors = false
        try {
            const { data } = await api.get(
                `/validacao/cnpjCpf?cnpj_cpf=${cnpj_cpf.replace(/\D/g, '')}`
            )
            if (data) {
                toast.error('Já existe uma conta com este CNPJ/CPF')
                errors = true
            }
        } catch (error) {
            toast.error('Ocorreu um erro')
            errors = true
        }
        let cnpj_cpf_only_number = cnpj_cpf.replace(/\D/g, '').length

        if (cnpj_cpf_only_number !== 11 && cnpj_cpf_only_number !== 14) {
            toast.error('Insira um cpf ou cnpj válido')
            errors = true
        }

        if (!validateDocument(cnpj_cpf.replace(/\D/g, ''))) {
            toast.error('Insira um cpf ou cnpj válido')
            errors = true
        }
        if (!type || type === 'Selecione') {
            toast.error('Por favor, informe o tipo da empresa')
            errors = true
        }

        if (zipcode.length !== 9) {
            toast.error('Zipcode inválido')
            errors = true
        }

        if (!address) {
            toast.error('Por favor, informe um endereço válido')
            errors = true
        }

        if (!number) {
            toast.error('Por favor, informe um número válido')
            errors = true
        }

        // if(!complement) {
        //     toast.error('Por favor, informe um complemento válido')
        //     errors = true
        // }

        if (!district) {
            toast.error('Por favor, informe um distrito válido')
            errors = true
        }

        if (!city) {
            toast.error('Por favor, informe um cidade válida')
            errors = true
        }

        if (!state || state === 'Selecione') {
            toast.error('Por favor, informe um estado válido')
            errors = true
        }

        return errors
    }

    async function hasStepthreeErrors(): Promise<boolean> {
        let errors = false
        // try {
        //     const { data } = await api.get(`/validacao/login?login=${login}`)
        //     if (data) {
        //         toast.error('Este login já está em uso')
        //         errors = true
        //     }
        // } catch (e) {
        //     toast.error('Ocorreu um erro')
        //     errors = true
        // }

        // if (!login) {
        //     toast.error('Por favor, insira um login válido')
        //     errors = true
        // }

        if (!password || !passwordConfirm) {
            toast.error('Por favor, insira uma senha')
            errors = true
        }

        if (password !== passwordConfirm) {
            toast.error('As senhas não correspondem')
            errors = true
        }

        if (!checkTerms) {
            toast.error('Você precisa aceitar os termos de uso')
            errors = true
        }

        return errors
    }

    async function handleSubmit() {
        const payload = {
            fantasy_name,
            type,
            cnpj_cpf: cnpj_cpf.replace(/\D/g, ''),
            zipcode: zipcode.replace(/\D/g, ''),
            address,
            number,
            complement,
            district,
            city,
            state,
            fone: fone.replace(/\D/g, ''),
            email,
            password,
        }
        dispatch(actions.registerRequest(payload))
    }
    const isStepOptional = (step: number) => {
        return false
    }

    const isStepSkipped = (step: number) => {
        return skipped.has(step)
    }

    const handleNext = async () => {
        try {
            if (activeStep === 0 && (await hasStepOneErrors())) {
                return
            }

            if (activeStep === 1 && (await hasSteptwoErrors())) {
                return
            }

            if (activeStep === 2) {
                if (await hasStepthreeErrors()) return
                await handleSubmit()
            }

            let newSkipped = skipped
            if (isStepSkipped(activeStep)) {
                newSkipped = new Set(newSkipped.values())
                newSkipped.delete(activeStep)
            }

            setActiveStep((prevActiveStep) => prevActiveStep + 1)
            setSkipped(newSkipped)
        } catch (err) {
            // const erro = get(err, 'response.data.error', '')
            // toast.error(erro)
        }
    }

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1)
    }

    const handleRedirect = () => {
        navigate('/login')
    }

    return (
        <Container>
            <Box sx={{ width: '100%' }}>
                <Stepper alternativeLabel activeStep={activeStep}>
                    {steps.map((label, index) => {
                        const stepProps: { completed?: boolean } = {}
                        const labelProps: {
                            optional?: React.ReactNode
                        } = {}
                        if (isStepOptional(index)) {
                            labelProps.optional = (
                                <Typography variant="caption">
                                    Optional
                                </Typography>
                            )
                        }
                        if (isStepSkipped(index)) {
                            stepProps.completed = false
                        }
                        return (
                            <Step key={label} {...stepProps}>
                                <StepLabel {...labelProps}>{label}</StepLabel>
                            </Step>
                        )
                    })}
                </Stepper>
                {activeStep === steps.length ? (
                    <React.Fragment>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                            {registerError
                                ? 'Ocorreu algum erro ao criar sua conta.'
                                : 'Sua conta foi criada com sucesso!'}
                        </Typography>
                        <Typography sx={{ mt: 2, mb: 1 }}>
                            {registerError
                                ? 'Por favor, tentente novamente e verifique se os dados estão certos.'
                                : 'Aguarde as proximas instruções no email, estamos verificando sua conta! Isso pode levar alguns minutos!'}
                        </Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                pt: 2,
                            }}
                        >
                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button onClick={handleRedirect}>
                                Ir para login
                            </Button>
                        </Box>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        {activeStep === 0 ? (
                            <CreateInitialDataStep
                                fantasy_name={fantasy_name}
                                setFantasy_name={setFantasy_name}
                                email={email}
                                setEmail={setEmail}
                                fone={fone}
                                setFone={setFone}
                            />
                        ) : (
                            <>
                                {activeStep === 1 ? (
                                    <CompanyDataStep
                                        type={type}
                                        setType={setType}
                                        cnpj_cpf={cnpj_cpf}
                                        setCnpj_cpf={setCnpj_cpf}
                                        zipcode={zipcode}
                                        setZipcode={setZipcode}
                                        address={address}
                                        setAddress={setAddress}
                                        number={number}
                                        setNumber={setNumber}
                                        complement={complement}
                                        setComplement={setComplement}
                                        district={district}
                                        setDistrict={setDistrict}
                                        city={city}
                                        setCity={setCity}
                                        state={state}
                                        setState={setState}
                                    />
                                ) : (
                                    <ChooseCompanyPlanStep
                                        email={email}
                                        password={password}
                                        setPassword={setPassword}
                                        passwordConfirm={passwordConfirm}
                                        setPasswordConfirm={setPasswordConfirm}
                                        checkTerms={checkTerms}
                                        setCheckTerms={setCheckTerms}
                                    />
                                )}
                            </>
                        )}

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                pt: 2,
                                mt: '30px',
                                mb: '30px',
                            }}
                        >
                            <Button
                                color="inherit"
                                //onClick={ ()=> setVisible(true) }
                                sx={{ mr: 1 }}
                                disabled={activeStep === 0}
                                onClick={handleBack}
                            >
                                Voltar
                            </Button>

                            <Box sx={{ flex: '1 1 auto' }} />
                            <Button onClick={handleNext}>
                                {activeStep === steps.length - 1
                                    ? 'Criar conta'
                                    : 'Próximo'}
                            </Button>
                        </Box>
                    </React.Fragment>
                )}
            </Box>
        </Container>
    )
}
